import React from 'react';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { datadogRum } from '@datadog/browser-rum';
import { initializeRealUserMonitoring } from '@eb/real-user-monitoring';

import { configureStore } from '@eb/redux-configure-store';
import { middleware as analyticsMiddleware } from '@eb/site-analytics';

import { BasePage } from '../base';
import { OverlayProvider } from '../../context/Overlay';

import { ConsumerHeader } from '../../components/ConsumerHeader';
import { ConfirmationOverlay } from '../../components/ConfirmationOverlay';

import reducer from '../../redux/reducers';
import { getInitialData } from '../../redux/reducers/utils';
import { isProd } from '../../utils/http';

import { SearchBaseContainer } from './containers';
import '../app.scss';

export class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialData(props),
            middleware: [thunk, analyticsMiddleware(props)],
        });
    }

    componentDidMount() {
        const { env } = this.props;

        if (isProd({ env })) {
            initializeRealUserMonitoring({
                sampleRate: 0.4,
                version: this.props.app_version,
                service: this.props.app_name,
                env: 'prod',
            });

            datadogRum.onReady(() =>
                datadogRum.addRumGlobalContext('view.sub_app', 'search'),
            );
        }
    }

    render() {
        return (
            <Provider store={this._store}>
                <OverlayProvider>
                    <BasePage
                        {...this.props}
                        isSearchPage={true}
                        structureHeader={ConsumerHeader}
                        removeOverflowSettings={true}
                    >
                        <ConfirmationOverlay />
                        <div className="feed-search-page">
                            <SearchBaseContainer {...this.props} />
                        </div>
                    </BasePage>
                </OverlayProvider>
            </Provider>
        );
    }
}

export default SearchPage;
